export { ProductContainer } from '@/domains/productDiscovery/ProductPage/b2c/modules/ProductContainer/ProductContainer';
